<script setup lang="ts">
import { useId } from 'vue';

const model = defineModel<boolean>({ default: false });

const { id = useId() } = defineProps<{
  id?: string;
  disabled?: boolean;
}>();

function onChange(event: Event) {
  model.value = (event.target as HTMLInputElement).checked;
}
</script>

<template>
  <div class="ui-toggle">
    <input
      :id="id"
      class="input"
      type="checkbox"
      :checked="model"
      :disabled="disabled"
      @change="onChange"
    />

    <label
      class="label"
      :for="id"
    />
  </div>
</template>

<style scoped lang="scss">
.input {
  display: none;

  &:checked {
    + .label {
      background-color: var(--color-yellow-600);

      &:after {
        background-color: var(--color-white);
        transform: translateX(14px);
      }
    }
  }

  &:not(:disabled) {
    &:checked {
      + .label {
        &:after {
          box-shadow: 0 0 0 0 rgb(255 195 0 / 30%); // var(--color-yellow-600)
        }

        @include hover {
          &:after {
            box-shadow: 0 0 0 6px rgb(255 195 0 / 30%); // var(--color-yellow-600)
          }
        }
      }
    }

    + .label {
      cursor: pointer;

      &:after {
        box-shadow: 0 0 0 0 rgb(157 164 180 / 30%); // var(--color-gray-500)
      }

      @include hover {
        &:after {
          box-shadow: 0 0 0 6px rgb(157 164 180 / 30%); // var(--color-gray-500)
        }
      }
    }
  }

  &:disabled {
    + .label {
      cursor: not-allowed;
      opacity: 0.5;
    }
  }
}

.label {
  position: relative;
  display: block;
  width: 34px;
  height: 20px;
  border-radius: 100px;
  background-color: var(--color-gray-200);
  transition:
    background-color var(--transition-fast),
    opacity var(--transition-fast);

  &:after {
    content: '';
    position: absolute;
    top: 3px;
    left: 3px;
    width: 14px;
    height: 14px;
    border-radius: 100px;
    background-color: var(--color-gray-500);
    transform: translateX(0);
    transition:
      background-color var(--transition-fast),
      box-shadow var(--transition-fast),
      transform var(--transition-fast);
  }
}
</style>
